"use client";
import { useSyncExternalStore } from "react";
import {
  subscribeNavigationActivity,
  automaticNavigationAllowed,
} from "./navigation-activity";

export function useAutomaticNavigationAllowed(): boolean {
  return useSyncExternalStore(
    subscribeNavigationActivity,
    automaticNavigationAllowed,
    () => true,
  );
}
